import { useNavigate, useRouterState } from '@tanstack/react-router';
import { MobileFrame } from '../shell/MobileFrame';
import { MasterTabBar } from './shell/MasterTabBar';
import type { MasterTab } from './types';
import type { ReactNode } from 'react';

interface MasterMobileRootProps {
  children: ReactNode;
}

const TAB_ROUTES: Record<MasterTab, string> = {
  geral: '/m/master',
  workspaces: '/m/master/workspaces',
  cobrancas: '/m/master/cobrancas',
  auditoria: '/m/master/auditoria',
  config: '/m/master/config',
};

function pathToTab(pathname: string): MasterTab {
  if (pathname.startsWith('/m/master/workspaces')) return 'workspaces';
  if (pathname.startsWith('/m/master/cobrancas')) return 'cobrancas';
  if (pathname.startsWith('/m/master/auditoria')) return 'auditoria';
  if (pathname.startsWith('/m/master/config')) return 'config';
  return 'geral';
}

/**
 * Shell mobile do usuário Master — 5 abas com acento lilás, sem FAB.
 * A tab ativa é derivada da rota atual.
 */
export function MasterMobileRoot({ children }: MasterMobileRootProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigate = useNavigate() as any;
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;

  const currentTab = pathToTab(pathname);

  function handleTabChange(tab: MasterTab) {
    navigate({ to: TAB_ROUTES[tab] });
  }

  return (
    <MobileFrame>
      <div
        style={{
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        {children}
      </div>
      <MasterTabBar current={currentTab} onChange={handleTabChange} />
    </MobileFrame>
  );
}
